<template>
  <div class="clients-page">
    <Header />
    
    <div class="page-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1>我们的客户</h1>
        <p>众多合作企业的信赖之选</p>
        <div class="scroll-indicator">
          <span>向下滚动了解更多</span>
          <i class="bi bi-chevron-down"></i>
        </div>
      </div>
    </div>
    
    <section class="clients-showcase" id="partners">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">优质合作</span>
          <h2>合作伙伴</h2>
          <div class="divider"></div>
          <p>信任是最好的合作基础</p>
        </div>
        
        <div class="clients-grid">
          <div class="client-item">
            <div class="client-logo logo-agility"></div>
            <div class="client-info">
              <h3>Agility Logistics</h3>
              <p>全球领先的物流服务提供商，为客户提供货运、仓储和供应链解决方案。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-logwin"></div>
            <div class="client-info">
              <h3>Logwin</h3>
              <p>国际知名的物流和运输企业，专注于提供综合性物流解决方案。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-bdp"></div>
            <div class="client-info">
              <h3>BDP International</h3>
              <p>全球领先的物流和运输管理公司，专注于提供私人定制的全球物流服务。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-zhinanzhen"></div>
            <div class="client-info">
              <h3>指北针科技</h3>
              <p>中国领先的互联网技术服务提供商，专注于数字化转型解决方案。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-nippon"></div>
            <div class="client-info">
              <h3>Nippon Express</h3>
              <p>日本最大的物流公司之一，提供全球综合物流服务。</p>
            </div>
          </div>
          
          <div class="client-item r">
            <div class="client-logo logo-liangxin"></div>
            <div class="client-info">
              <h3>良信电器</h3>
              <p>中国领先的低压电器制造商，专注于电力设备和智能电气产品。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-nanrui"></div>
            <div class="client-info">
              <h3>国电南瑞</h3>
              <p>中国电力系统自动化领域的领军企业，专注于智能电网解决方案。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-yyt"></div>
            <div class="client-info">
              <h3>怡亚通供应链</h3>
              <p>中国领先的供应链服务提供商，专注于供应链管理和创新解决方案。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-sgcc"></div>
            <div class="client-info">
              <h3>国家电网</h3>
              <p>中国国有电网运营商，负责中国大部分地区的电力输送和分配。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-sdv"></div>
            <div class="client-info">
              <h3>SDV</h3>
              <p>全球领先的供应链解决方案提供商，现为博罗来集团旗下品牌。</p>
            </div>
          </div>
          
          <div class="client-item">
            <div class="client-logo logo-hijia"></div>
            <div class="client-info">
              <h3>嗨家</h3>
              <p>新兴的互联网家居服务平台，致力于提供高质量的家居产品和服务。</p>
            </div>
          </div>
          
          <div class="client-item r">
            <div class="client-logo logo-yingda"></div>
            <div class="client-info">
              <h3>盈达</h3>
              <p>专业的物流和供应链管理公司，为客户提供定制化的物流解决方案。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="testimonials">
      <div class="container">
        <div class="section-title">
          <h2>客户评价</h2>
          <div class="divider"></div>
          <p>客户的持续信赖是对我们服务的最好认可</p>
        </div>
        
        <div class="testimonial-slider">
          <div class="testimonial-item">
            <div class="quote-mark left-quote">
              <i class="bi bi-quote"></i>
            </div>
            <p class="content">俊采猎头在人才寻访方面表现出色，他们精准理解我们的需求，为我们推荐的候选人非常符合岗位要求和企业文化。他们的专业程度和服务质量让我们印象深刻。</p>
            <div class="quote-mark right-quote">
              <i class="bi bi-quote flip-right"></i>
            </div>
            <div class="author">
              <div class="name">张先生</div>
              <div class="position">某物流企业人力资源总监</div>
            </div>
          </div>
          
          <div class="testimonial-item">
            <div class="quote-mark left-quote">
              <i class="bi bi-quote"></i>
            </div>
            <p class="content">与俊采合作已有三年，他们的团队非常专业，对行业有深刻了解，能够快速响应我们的需求，提供高效优质的猎头服务。</p>
            <div class="quote-mark right-quote">
              <i class="bi bi-quote"></i>
            </div>
            <div class="author">
              <div class="name">李女士</div>
              <div class="position">某互联网企业CEO</div>
            </div>
          </div>
          
          <div class="testimonial-item">
            <div class="quote-mark left-quote">
              <i class="bi bi-quote"></i>
            </div>
            <p class="content">俊采猎头在电力行业人才寻访方面有独特优势，他们为我们找到了多位优秀的高管和技术人才，为公司的发展注入了新的活力。</p>
            <div class="quote-mark right-quote">
              <i class="bi bi-quote"></i>
            </div>
            <div class="author">
              <div class="name">王总</div>
              <div class="position">某新能源企业总经理</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'ClientsPage',
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped>
.clients-page {
  overflow-x: hidden;
}

.page-banner {
  height: 500px;
  background-image: url('@/assets/wallpaper5.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.banner-content {
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-content h1 {
  font-size: 42px;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-weight: 700;
}

.banner-content p {
  font-size: 20px;
  margin-bottom: 30px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  animation: bounce 2s infinite;
  text-align: center;
}

.scroll-indicator span {
  font-size: 14px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.scroll-indicator i {
  font-size: 20px;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title .subtitle {
  display: inline-block;
  color: #009688;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  position: relative;
}

.section-title .subtitle:before, .section-title .subtitle:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: #009688;
}

.section-title .subtitle:before {
  left: -30px;
}

.section-title .subtitle:after {
  right: -30px;
}

.section-title h2 {
  font-size: 32px;
  margin-bottom: 15px;
  color: #1a2b2b;
  font-weight: 700;
}

.divider {
  width: 60px;
  height: 3px;
  background-color: #009688;
  margin: 0 auto 20px;
}

.section-title p {
  font-size: 16px;
  color: #6a7676;
}

.clients-showcase {
  padding: 100px 0;
  background-color: #fff;
  position: relative;
}

.clients-showcase:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 L0,100 Z" fill="rgba(0,150,136,0.03)"/></svg>');
  background-size: 20px 20px;
  opacity: 0.5;
}

.clients-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1155px;
  margin: 0 auto;
  justify-content: space-between;
}

.client-item {
  width: 270px;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background-color: #fff;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  border: 1px solid #eef1f0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color 0.4s ease;
}

.client-item:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.client-logo {
  width: 230px;
  height: 150px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.client-logo::before,
.client-logo::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.5s ease;
}

.client-logo::after {
  transform: translateY(100%);
}

.client-logo:hover::before {
  transform: translateY(-100%);
}

.client-logo:hover::after {
  transform: translateY(0);
}

.logo-agility::before { 
  background-image: url('@/assets/sprites/image0.png');
}
.logo-agility::after {
  background-image: url('@/assets/sprites/image15.png');
}

.logo-logwin::before { 
  background-image: url('@/assets/sprites/image1.png');
}
.logo-logwin::after {
  background-image: url('@/assets/sprites/image16.png');
}

.logo-bdp::before { 
  background-image: url('@/assets/sprites/image2.png');
}
.logo-bdp::after {
  background-image: url('@/assets/sprites/image17.png');
}

.logo-zhinanzhen::before { 
  background-image: url('@/assets/sprites/image3.png');
}
.logo-zhinanzhen::after {
  background-image: url('@/assets/sprites/image18.png');
}

.logo-nippon::before { 
  background-image: url('@/assets/sprites/image4.png');
}
.logo-nippon::after {
  background-image: url('@/assets/sprites/image19.png');
}

.logo-liangxin::before { 
  background-image: url('@/assets/sprites/image5.png');
}
.logo-liangxin::after {
  background-image: url('@/assets/sprites/image20.png');
}

.logo-nanrui::before { 
  background-image: url('@/assets/sprites/image6.png');
}
.logo-nanrui::after {
  background-image: url('@/assets/sprites/image21.png');
}

.logo-yyt::before { 
  background-image: url('@/assets/sprites/image7.png');
}
.logo-yyt::after {
  background-image: url('@/assets/sprites/image22.png');
}

.logo-sgcc::before { 
  background-image: url('@/assets/sprites/image8.png');
}
.logo-sgcc::after {
  background-image: url('@/assets/sprites/image23.png');
}

.logo-sdv::before { 
  background-image: url('@/assets/sprites/image9.png');
}
.logo-sdv::after {
  background-image: url('@/assets/sprites/image24.png');
}

.logo-hijia::before { 
  background-image: url('@/assets/sprites/image10.png');
}
.logo-hijia::after {
  background-image: url('@/assets/sprites/image25.png');
}

.logo-yingda::before { 
  background-image: url('@/assets/sprites/image11.png');
}
.logo-yingda::after {
  background-image: url('@/assets/sprites/image26.png');
}

.client-info {
  padding: 20px;
  flex: 1;
  background-color: #fff;
  border-top: 3px solid #009688;
}

.client-info h3 {
  font-size: 18px;
  margin: 0 0 10px;
  color: #1a2b2b;
  font-weight: 600;
}

.client-info p {
  font-size: 14px;
  line-height: 1.5;
  color: #6a7676;
  margin: 0;
}

.testimonials {
  padding: 100px 0;
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;
}

.testimonials:before {
  content: "";
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: rgba(0, 150, 136, 0.1);
}

.testimonials:after {
  content: "";
  position: absolute;
  bottom: -50px;
  left: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: rgba(0, 150, 136, 0.1);
}

.testimonial-slider {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.testimonial-item {
  flex: 1 1 300px;
  background-color: #fff;
  padding: 40px 30px;
  border-radius: 16px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  position: relative;
  overflow: hidden;
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color 0.4s ease;
}

.testimonial-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.testimonial-item:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.testimonial-item:hover::before {
  transform: scaleX(1);
}

.quote-mark {
  position: absolute;
}

.left-quote {
  top: 24px;
  left: 24px;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  color: #fff;
  box-shadow: 0 8px 18px rgba(0, 150, 136, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  z-index: 2;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.testimonial-item:hover .left-quote {
  transform: translateY(-4px) rotate(-6deg);
}

.right-quote {
  bottom: 125px;
  right: 20px;
  color: rgba(0, 150, 136, 0.14);
  font-size: 40px;
  transform: rotate(180deg);
}

.testimonial-item .content {
  font-size: 16px;
  line-height: 1.8;
  margin: 20px 0 40px;
  color: #6a7676;
  position: relative;
  z-index: 1;
}

.testimonial-item .author {
  border-top: 1px solid #eee;
  padding-top: 15px;
  position: relative;
  z-index: 1;
}

.testimonial-item .name {
  font-size: 18px;
  font-weight: bold;
  color: #1a2b2b;
  margin-bottom: 5px;
}

.testimonial-item .position {
  font-size: 14px;
  color: #009688;
}

@media (max-width: 1200px) {
  .clients-grid {
    max-width: 950px;
  }

  .client-item {
    width: 220px;
  }

  .client-logo {
    transform: scale(0.9);
    transform-origin: center center;
  }
}

@media (max-width: 992px) {
  .clients-grid {
    max-width: 700px;
    justify-content: space-around;
  }

  .client-item {
    width: 320px;
  }

  .client-logo {
    transform: scale(1);
    transform-origin: center center;
  }
}

@media (max-width: 768px) {
  .page-banner {
    height: 400px;
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 18px;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .clients-showcase, .testimonials {
    padding: 80px 0;
  }
  
  .clients-grid {
    max-width: 500px;
  }

  .client-item {
    width: 230px;
  }

  .client-logo {
    transform: scale(0.85);
    transform-origin: center center;
  }
}

@media (max-width: 500px) {
  .clients-grid {
    max-width: 320px;
  }

  .client-item {
    width: 100%;
  }
  
  .client-logo {
    transform: scale(0.75);
    transform-origin: center center;
  }
  
  .testimonial-item {
    padding: 30px 20px;
  }
  
  .quote-mark {
    font-size: 30px;
  }
}
</style> 